import { OperationVariables, QueryResult, useQuery } from '@apollo/client';
import FIND_ONE_STUDENT_ASSESSMENTS from 'graph/queries/student-assessment/find-one-student-assessment';
import FIND_STUDENT_ASSESSMENTS from 'graph/queries/student-assessment/find-student-assessments';
import GET_STUDENT_ASSESSMENT from 'graph/queries/student-assessment/get-student-assessment';
import { StudentAssessment } from 'types';

export type StudentAssessmentStoreState = {
  studentAssessment?: StudentAssessment;
  studentAssessments?: StudentAssessment[];
  loading: boolean;
};

export type StudentAssessmentStoreDispatch = {
  studentAssessmentRefetch: any;
};
export type StudentAssessmentStore = [StudentAssessmentStoreState, StudentAssessmentStoreDispatch];

const variables: OperationVariables = {
  where: { id: '', studentAssessmentId: {} },
};

const useStudentAssessmentStore = (id: number): StudentAssessmentStore => {
  variables.where.id = id;
  const {
    data,
    loading,
    //    error,
    refetch: studentAssessmentRefetch,
  }: QueryResult<{ studentAssessment: StudentAssessment }> = useQuery(GET_STUDENT_ASSESSMENT, {
    variables: variables,
  });

  return [
    {
      studentAssessment: data?.studentAssessment,
      loading,
    },
    {
      studentAssessmentRefetch,
    },
  ];
};

export const useFindStudentAssessmentsStore = (
  assessmentId: number,
  studentId
): StudentAssessmentStore => {
  variables.where.assessmentId = assessmentId;
  variables.where.studentId = studentId;

  const {
    data,
    loading,
    //    error,
    refetch: studentAssessmentRefetch,
  }: QueryResult<{ studentAssessments: StudentAssessment[] }> = useQuery(FIND_STUDENT_ASSESSMENTS, {
    variables: variables,
  });

  return [
    {
      studentAssessments: data?.studentAssessments,
      loading,
    },
    {
      studentAssessmentRefetch,
    },
  ];
};

export const useFindOneStudentAssessmentStore = (
  assessmentId: number,
  studentId: number
): StudentAssessmentStore => {
  variables.where.studentAssessmentId.assessmentId = assessmentId;
  variables.where.studentAssessmentId.studentId = studentId;
  delete variables.where.id;
  const {
    data,
    loading,
    //    error,
    refetch: studentAssessmentRefetch,
  }: QueryResult<{ studentAssessment: StudentAssessment }> = useQuery(
    FIND_ONE_STUDENT_ASSESSMENTS,
    {
      variables: variables,
    }
  );

  return [
    {
      studentAssessment: data?.studentAssessment,
      loading,
    },
    {
      studentAssessmentRefetch,
    },
  ];
};

export default useStudentAssessmentStore;
